module.exports = __webpack_public_path__ + "static/media/greg.688b3da9.png";